import styles from './ListNavigation.module.css';

import { useListDrawerContext } from '../ListDrawerProvider';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

const ListItem = ({ item, cellClassName = undefined }) => {
  const { selected, selectedKey, setSelected } = useListDrawerContext();

  const [isSelectedRow, setIsSelectedRow] = useState(false);

  useEffect(() => {
    setIsSelectedRow(selected === item[selectedKey]);
  }, [selected]);

  return (
    <tr
      className={classNames(styles.rowItem, { [styles.active]: isSelectedRow })}
      onClick={() => setSelected(item[selectedKey])}
    >
      <td colSpan={2} className={classNames(styles.item, styles.defaultItem, cellClassName)}>
        <div className={styles.itemName}>{item.name}</div>
        <div
          className={classNames({ [styles.underline]: item.is_editable || item.is_deletable })}
        ></div>
      </td>
    </tr>
  );
};

export default ListItem;
